import type { TProjectStatus } from '@feathr/extender/components/ProjectStatusSegmentedControl';
import type { IObject } from '@feathr/rachis';

/**
 * Single source of truth for the Active/Hidden project filter, shared by the
 * Projects grid and the segment count badges so the two can never drift.
 *
 * Active treats a missing/false `is_hidden` as not hidden (`is_hidden__ne: true`)
 * so legacy projects without the field stay in the default view; Hidden shows
 * only explicitly hidden projects (`is_hidden: true`).
 */
export function buildProjectStatusFilter(status: TProjectStatus): IObject {
  return status === 'hidden' ? { is_hidden: true } : { is_hidden__ne: true };
}
